export default __webpack_public_path__ + "static/media/1.60748b40.png";